/**
 * Requesting stories for the main article view
 * @author Vinny DeFrancesco, Ryan Gladstone
 */

function StoriesController(
  $scope,
  filtersService,
  searchService,
  enableRefresh
) {
  const ctrl = this;

  // initialize search and load stories
  $scope.search = searchService.search({
    name: 'storiesSearch',
    type: 'stories',
    refresh: enableRefresh
  });

  $scope.refresh = $scope.search.refresh;
  $scope.filterSet = $scope.search.filterSet;

  $scope.platformsFilter = $scope.filterSet.getFilter('platforms');
  $scope.sectionsFilter = $scope.filterSet.getFilter('sections');

  $scope.defaultFilters = filtersService.defaultFilters;

  // determine plan-type
  ctrl.setPlanType = (filterSet) => {
    const platformsVal = filterSet.getFilterValue('platforms');
    const sectionsVal = filterSet.getFilterValue('sections');

    if (platformsVal && platformsVal.length) {
      return 'platforms';
    }

    if (sectionsVal && sectionsVal.length) {
      return 'sections';
    }

    return 'sections';
  };

  $scope.planType = ctrl.setPlanType($scope.filterSet);

  function updateStatsParams() {
    $scope.statsParams.sec = $scope.filterSet.getFilterValue('sections');
    $scope.statsParams.pl = $scope.filterSet.getFilterValue('platforms');
  }

  function calcPlanType() {
    const newType = ctrl.setPlanType($scope.filterSet);

    if (newType !== $scope.planType) {
      $scope.planType = newType;
    }
    updateStatsParams();
  }

  $scope.$watch('platformsFilter.value', calcPlanType);
  $scope.$watch('sectionsFilter.value', calcPlanType);

  $scope.statsParams = {};

  // if(!enableRefresh){
  //   var filter = $scope.filterSet.getFilter('selectedPlan');
  //   filter.changeValue($scope.filterSet.getFilterValue('plan'));
  // }

  $scope.$on('$destroy', () => {
    $scope.search.tearDown();
  });
}

const arr = [
  '$scope',
  'filtersService',
  'searchService',
  'enableRefresh',
  'featureFlag',
  StoriesController
];

export default function (ngModule) {
  ngModule.controller('StoriesController', arr);
}
